"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSeriesQuerySchema = exports.updateSeriesSchema = exports.createSeriesSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
const SERIES_DOC_TYPE_VALUES = Object.values(enums_1.SeriesDocType);
// Bare (undefaulted) field definitions, shared by create and update. Zod's
// `.default()` fires on ANY `undefined` input — including a field simply
// absent from a PATCH body — even after `.partial()`; applying `.default()`
// here and reusing this object for `updateSeriesSchema.partial()` would
// mean a PATCH `{isActive: false}` alone silently resets padding/
// startNumber/yearlyReset/isDefault back to their create-time defaults on
// every update. Defaults are therefore only layered on in
// `createSeriesSchema` below, never on the shape update reuses.
const seriesFields = {
    docType: zod_1.z.enum(SERIES_DOC_TYPE_VALUES, 'Tip document invalid.'),
    // Exact regex per spec: starts with an uppercase letter, followed by up to
    // 11 more uppercase letters/digits (1-12 chars total).
    prefix: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Z][A-Z0-9]{0,11}$/, 'Prefixul trebuie să înceapă cu o literă mare și să conțină doar litere mari și cifre (1-12 caractere).'),
    padding: zod_1.z.coerce.number('Padding-ul trebuie să fie un număr.').int().min(1).max(8),
    startNumber: zod_1.z.coerce.number('Numărul de start trebuie să fie un număr.').int().min(1),
    yearlyReset: zod_1.z.boolean(),
    isDefault: zod_1.z.boolean(),
    isActive: zod_1.z.boolean(),
};
exports.createSeriesSchema = zod_1.z.object({
    ...seriesFields,
    padding: seriesFields.padding.default(4),
    startNumber: seriesFields.startNumber.default(1),
    yearlyReset: seriesFields.yearlyReset.default(false),
    isDefault: seriesFields.isDefault.default(false),
    isActive: seriesFields.isActive.default(true),
});
// prefix/startNumber/padding/yearlyReset/docType are only actually editable
// while the series is unused — SeriesService.update() is the authoritative
// gate for that (409 SERIES_IN_USE otherwise); this schema only validates
// the *format* of whatever fields happen to be present in a given PATCH.
// Built from the undefaulted `seriesFields` (see comment above) so an
// omitted field stays truly absent instead of reappearing as its
// create-time default.
exports.updateSeriesSchema = zod_1.z.object(seriesFields).partial();
exports.listSeriesQuerySchema = zod_1.z.object({
    docType: zod_1.z.enum(SERIES_DOC_TYPE_VALUES, 'Tip document invalid.').optional(),
});
